import { render, staticRenderFns } from "./FusionScatter.vue?vue&type=template&id=21abc837&scoped=true"
import script from "./FusionScatter.vue?vue&type=script&lang=js"
export * from "./FusionScatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21abc837",
  null
  
)

export default component.exports